import { MakeCall } from './createMakeCall';
import { BookingModificationPayload } from './types/BookingModificationDetails';

// respond with accept or decline for a booking modification request by landlord
const accceptOrDeclineBookingModificationRequest =
  (makeCall: MakeCall) =>
  (
    conversationId: number,
    changeRequestID: number,
    payload?: BookingModificationPayload,
  ) =>
    makeCall<BookingModificationPayload>(
      'POST',
      `/api/v2/conversation/${conversationId}/change/${changeRequestID}`,
      { data: payload },
    );
export { accceptOrDeclineBookingModificationRequest };
